"use client";

import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TestimonySection: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000
  };

  const reviews = [
    {
      id: 1,
      review: '"Nikada nisam bila zadovoljnija svojom frizurom! Frizeri su pažljivi, profesionalni i tačno znaju šta mi treba. Svaki put izađem sa osmehom na licu!"',
      person: "Natalija Mihajlovic",
      occupation: "Advokat"
    },
    {
      id: 2,
      review: '"Od trenutka kada sam ušla, osetila sam se dobrodošlom. Atmosfera je opuštena, a usluga vrhunska. Preporučujem šišanje svakome!"',
      person: "Jelena Niketic",
      occupation: "Sudija"
    },
    {
      id: 3,
      review: '"Pronašla sam svoje mesto za frizuru! Usluga je besprekorna, frizeri su ljubazni i predlože stil koji mi savršeno stoji. Hvala vam!"',
      person: "Kristina Milicevic",
      occupation: "Pravnik"
    },
    {
      id: 4,
      review: '"Obožavam kako se brinu o detaljima. Koriste kvalitetne proizvode, a usluga šišanja i stilizovanja je na svetskom nivou. Sve pohvale!"',
      person: "Milica Petrovic",
      occupation: "Student"
    },
    {
      id: 5,
      review: '"Svaki put kada se spremam za važan događaj, dolazim ovde. Frizeri su neverovatno talentovani i uvek mi naprave frizuru iz snova!"',
      person: "Petar Milić",
      occupation: "Advokat"
    },
  ]

  return (
    <section id='testimonials' className="testimony-section bg-light py-5">
      <div className="container" style={{ width: "90%" }}>
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5 d-flex">
            <div
              className="testimony-img"
              style={{
                backgroundImage: "url(images/testimony-img.jpg)",
                borderRadius: "20px",
              }}
            ></div>
          </div>
          <div className="col-md-6 col-lg-7 py-5 pl-md-5">
            <div className="py-md-5">
              <div className="heading-section">
                <span className="subheading">Utisci</span>
                <h2 className="mb-0">Zadovoljni klijenti</h2>
              </div>

              <Slider {...settings}>
                {reviews.map((item) => (
                  <div key={item.id}>
                    <div className="testimony-wrap pb-4">
                      <div className="text">
                        <p className="mb-4" style={{ fontStyle: 'italic' }}>
                          {item.review}
                        </p>
                      </div>
                      <div className="d-flex">
                        <div
                          className="user-img"
                          style={{
                            backgroundImage: `url(images/stylist-${item.id}.jpg)`,
                          }}
                        ></div>
                        <div className="pos ml-3">
                          <p className="name">{item.person}</p>
                          <span className="position">{item.occupation}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonySection;
